import { FetchContext } from '../fetch-context';
import { EmailTemplateRef } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getEmailTemplateRefs: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<EmailTemplateRef[]> = (fetchContext, programId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/email-templates/refs`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<EmailTemplateRef[]>(fetchContext.errorStore, response, 'get email template refs'));
